import { DialogActions as MUIDialogActions, DialogActionsProps } from '@mui/material';
import { mergeSX } from '../../../../services/helpers';

const buildSX = ({
  paddingTop,
  paddingBottom,
}: IBuildSXParams) => ({
  paddingX: 2,
  paddingTop,
  paddingBottom,
});

interface IBuildSXParams {
  paddingTop: number | string;
  paddingBottom: number | string;
}

interface IDialogActions extends DialogActionsProps {
  paddingTop?: number | string;
  paddingBottom?: number | string;
}

const DialogActions = (props: IDialogActions) => {
  const {
    children,
    paddingTop = 2,
    paddingBottom = 2,
    sx,
    ...restProps
  } = props;
  return (
    <MUIDialogActions
      sx={mergeSX(buildSX({ paddingTop, paddingBottom }), sx)}
      {...restProps}
    >
      {children}
    </MUIDialogActions>
  );
};

export default DialogActions;
